import { render } from "./AdminListSection.vue?vue&type=template&id=6acc6169&scoped=true"
import script from "./AdminListSection.vue?vue&type=script&lang=js"
export * from "./AdminListSection.vue?vue&type=script&lang=js"

import "./AdminListSection.vue?vue&type=style&index=0&id=6acc6169&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acc6169"]])

export default __exports__